"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _EnvIndicator = _interopRequireDefault(require("../../elements/env/EnvIndicator"));

var _DesktopTabletView = _interopRequireDefault(require("../../elements/view/DesktopTabletView"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var NavBarSignoutStyle = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex flex-row info-bar fixed-top align-items-center",
    id: "best-navbar-signout"
  };
}).withConfig({
  displayName: "NavbarSignout__NavBarSignoutStyle",
  componentId: "mibrb0-0"
})(["&&&{background-color:", ";z-index:1052;height:22px;}"], function (props) {
  return props.color ? props.color : props.theme["white"];
});

var EnvHolder = _styledComponents["default"].div.withConfig({
  displayName: "NavbarSignout__EnvHolder",
  componentId: "mibrb0-1"
})(["width:65px;height:22px;"]);

var NavbarSignout = function NavbarSignout(_ref) {
  var loggedIn = _ref.loggedIn,
      children = _ref.children,
      color = _ref.color,
      displayEnvIndicator = _ref.displayEnvIndicator,
      env = _ref.env;
  return _react["default"].createElement("div", null, _react["default"].createElement(_DesktopTabletView["default"], null, loggedIn ? _react["default"].createElement(NavBarSignoutStyle, {
    color: color
  }, displayEnvIndicator ? _react["default"].createElement(EnvHolder, null, _react["default"].createElement(_EnvIndicator["default"], {
    env: env
  })) : "", _react["default"].createElement("div", {
    className: "ml-auto"
  }, children)) : ""));
};

NavbarSignout.propTypes = {
  loggedIn: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  displayEnvIndicator: _propTypes["default"].bool,
  env: _propTypes["default"].string,
  color: _propTypes["default"].string
};
NavbarSignout.defaultProps = {
  displayName: "nav-bar-signout",
  displayEnvIndicator: true,
  env: "dev",
  color: null
};
var _default = NavbarSignout;
exports["default"] = _default;